import { Alert } from 'antd';
import React from 'react';

const AlertEmptyProject = () => {
    return (
        <div style={{ padding: 30 }}>
            <Alert
                message="Select project"
                description="Please select a project from the project filter."
                type="warning"
                showIcon
                closable
            />
        </div>
    );
};

export default AlertEmptyProject;
